import { configureStore } from '@reduxjs/toolkit';

// Reducer placeholder - adicione seus reducers aqui futuramente
const placeholderReducer = (state = {}) => state;

export const store = configureStore({
  reducer: {
    placeholder: placeholderReducer,
  },
});

export default store;
